import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import Loading from "../Loading"

export default function LoadingFade(){
    const loader = useRef()
    const router = useLocation()

    useEffect(()=> {
        if (loader.current) {
            loader.current.classList.remove("fadeOut")
            setTimeout(()=> {
                if (loader.current) loader.current.classList.add("fadeOut")
            }, 1000)
        }
    }, [router])

    return <Loading ref={loader} />
}
